export default __webpack_public_path__ + "static/media/Store_Read.8fbf4ae0.svg";